import { ItinerantRescheduleTemplate } from "../../Templates/ItinerantRescheduleTemplate";

export const ItinerantReschedule = () => {
  return <ItinerantRescheduleTemplate />;
};
